// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a1iX8","inner":"styles_inner__1cKii","right":"styles_right__7ikZU","close":"styles_close__2i7iQ","footer":"styles_footer__2p3x0"};